export const percentagePipe = (e: string) => e+"%"
export const cubicMeterPipe = (e: string) => e+""